/**
 * 图生文固定工具配置
 * 统一为一个 AI 图像分析工具，支持多工具类型同时选择。
 */

export interface ImageToTextToolConfig {
  /** 工具唯一标识，也用于构造路由 */
  id: string
  /** 展示标题 */
  title: string
  /** 一句话描述 */
  description: string
  /** 封面/图标 emoji */
  icon: string
  /** 路由地址 */
  href: string
}

export const AI_ANALYSIS_TOOL: ImageToTextToolConfig = {
  id: 'ai-analysis',
  title: 'AI 图像分析',
  description: '批量上传图片，同时进行标题生成、侵权检测、提示词反推',
  icon: '🔬',
  href: '/tools/ai-analysis',
}

export const IMAGE_TO_TEXT_TOOLS: ImageToTextToolConfig[] = [AI_ANALYSIS_TOOL]

/**
 * 根据 id 查找工具配置（向后兼容）
 */
export function findImageToTextTool(id: string): ImageToTextToolConfig | undefined {
  return IMAGE_TO_TEXT_TOOLS.find((tool) => tool.id === id)
}
